import { memo } from 'react';

import DateIconSVG from '@/assets/date-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IDateIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={DateIconSVG} {...props} />;

export const DateIcon = memo(IDateIcon) as typeof IDateIcon;
